import React, { useState } from "react";

const TENNIS04_URL = "https://www.tennis04.com/thedinghausen";

function CourtBooking() {
  const [loadError, setLoadError] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 60px)" }}>
      {loadError ? (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, padding: 24 }}>
          <p style={{ textAlign: "center", color: "#555" }}>
            Die Buchungsseite kann leider nicht direkt eingebettet werden.
          </p>
          <a
            href={TENNIS04_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ padding: "10px 20px", background: "#1a73e8", color: "#fff", borderRadius: 6, textDecoration: "none", fontWeight: 600 }}
          >
            Zur Buchungsseite
          </a>
        </div>
      ) : (
        <iframe
          src={TENNIS04_URL}
          title="Platzbuchung tennis04"
          style={{ flex: 1, border: "none", width: "100%" }}
          onError={() => setLoadError(true)}
        />
      )}
    </div>
  );
}

export default CourtBooking;
